// extracted by mini-css-extract-plugin
export default {"VirtualVenueDisplayContainer":"VirtualVenueDisplayLayout_VirtualVenueDisplayContainer__l5TkY"};